export const welcomeTitle = "Full stack engineer based in the United Kingdom";
export const welcomeMessage = "April 2020 saw the conclusion of a nine-month online Computer and Software Engineering course. 2,000 hours of intensive, hands-on experience, working with people from around the world."

export const button = "Hire me"

export const introduction = [
  {
    title: "History",
    content: "A qualified and experienced mechanical engineer, I studied at the University of Loughborough. Having solely worked in the oil and gas industry, I've now turned my hand to software.",
    section: 'Time line',
  },
  {
    title: "Skills",
    content: "Computer literate. Experienced with maintenance management and risk management systems. Proficient with the MS Office suite including Word and Excel.",
    section: 'Experience',
  },
  {
    title: "Teamwork",
    content: "Worked remotely and across time zones with people around the world. Sharing a project is much more fun than working alone and inevitably leads to a better product.",
    section: 'Experience',
  },
  {
    title: "Coding",
    content: "Comfortable with React, vanilla JavaScript, Node JS and styled components, all the things used to build this portfolio. Familiar with Redux, Python, less, mySql and knex.",
    section: 'Experience',
  },
  {
    title: "Interface",
    content: "Apps should be simple and intuitive to use, easy to navigate and fully responsive. I've always believed that simple is better than complex and strive to achieve this.",
    section: 'About me',
  },
];
